<!--
 * @Author: shijian.chen shijian.chen@qunar.com
 * @Date: 2022-11-21 10:24:46
 * @LastEditors: shijian.chen shijian.chen@qunar.com
 * @LastEditTime: 2022-12-16 17:26:25
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/estee202211/components/gotomini.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <wx-open-launch-weapp
      v-if="isBrowser()"
      id="launch-btn"
      username="gh_35505ba2ec3f"
      style="width: 168px; height: 140px;position:absolute;left:0;top:0;z-index:10"
      path="/pages/pagesPrizes/game/index.html?activeId=9&__key_=16699619163054"
    >
      <script type="text/wxtag-template">
        <div style="width:343px;height:140px;"></div>
      </script>
    </wx-open-launch-weapp>
    <div style="width:168px;height:140px;position:absolute;left:0;top:0;z-index:10" @click="gotomini" v-if="!isBrowser()">
        
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    try {
      var btn = document.getElementById("launch-btn");
      btn.addEventListener("launch", (e) => {
        this.$emit("gotomini")
      });
    } catch (error) {}
  },
  methods: {
    gotomini() {
      this.$emit("gotomini")
      location.href =
        window.hysdk.sniff.scheme +
        "://miniprogram/launchMiniProgram?userName=gh_35505ba2ec3f&path="+encodeURIComponent('/pages/pagesPrizes/game/index.html?activeId=9&__key_=16699619163054');
    },
    isBrowser() {
      if (window.hysdk.sniff.scheme) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style lang="less" scoped="true">
</style>